import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TableCell } from '@mui/material';
import moment from 'moment';
import { TableWidgetV2 } from '../../../components/v2';
import { getMaxColumnLength } from '../../../utils';
import * as actionsDrones from '../../../store/drone/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Role from '../../../constants/role';
import HistoricoModal from './HistoricoModal';

const tipoHistoricoNome = (tipo) => {
  switch (tipo) {
    case 'MANUTENCAO': return 'Manutenção';
    case 'REPASSE': return 'Repasse';
    case 'VENDA_TROCA': return 'Venda/Troca';
    default: return tipo;
  }
};

const ordernarPorDataHistorico = (a, b) => b.dataHistorico.localeCompare(a.dataHistorico);

const HistoricoTab = ({ idDrone, historico, userRole, deleteHistoricoDrone }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [historicoDroneId, setHistoricoDroneId] = useState(null);

  const isAdmin = userRole === Role.ADMIN || userRole === Role.SUPER_ADMIN;

  useEffect(() => {
    setRows(historico || []);
  }, [historico]);

  const renderRows = (h) => (
    <>
      <TableCell>{moment(h.dataHistorico).format('DD/MM/YYYY')}</TableCell>
      <TableCell>{tipoHistoricoNome(h.tipoHistorico)}</TableCell>
      <TableCell title={h.observacao}>{getMaxColumnLength(h.observacao)}</TableCell>
    </>
  );

  const onDelete = (id) => {
    deleteHistoricoDrone(id, () => {
      setRows((prev) => prev.filter((s) => s.id !== id));
    });
  };

  const afterSave = (data) => {
    setRows((prev) => [...prev.filter((s) => s.id !== data.id), data].sort(ordernarPorDataHistorico));
  };

  return (
    <>
      <TableWidgetV2
        rows={rows}
        titles={['Data', 'Tipo', 'Descrição']}
        deleteMessage="A informação será removida e não poderá ser mais recuperada."
        renderRows={renderRows}
        hasRowActions={isAdmin}
        onEdit={(id) => { setHistoricoDroneId(id); setOpen(true); }}
        onAdd={() => { setHistoricoDroneId(null); setOpen(true); }}
        onDelete={onDelete}
        showEdit={isAdmin}
        showDelete={isAdmin}
        hasAdd={isAdmin}
      />
      <HistoricoModal
        open={open}
        onClose={() => { setHistoricoDroneId(null); setOpen(false); }}
        idDrone={idDrone}
        id={historicoDroneId}
        afterSave={afterSave}
      />
    </>
  );
};

const mapStateToProps = (state) => ({ userRole: selectorsAuth.getRole(state) });
const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsDrones }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(HistoricoTab);
